import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getBranchRole,
  getParticularPage,
  getNext,
  getPrevious,
  createBranchRole,
  updateBranchRole,
  handleSearch,
  loadOptionsBranchRolePermission,
  getBranchRoleById,
} from "./thunk";

const initialState = {
  branchRoles: [],
  edit: false,
  branchRole: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBranchRole: false,
  loadingNext: false,
  unAssignedPermissions: [],
  assignedPermissions: [],
  showCreateModal: false,
};

export const branchRoleSlice = createSlice({
  name: "branchRole",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    branchRoleEditSuccess: (state, action) => {
      state.edit = true;
      state.branchRole = state.branchRoles.find((branchRole) => branchRole.id === action.payload);
    },

    // userGroupEditSuccess: (state, action) => {
    //   state.edit = true;
    //   state.userGroup = state.userGroups.find((userGroup) => userGroup.id === action.payload);
    //   state.permissions = [];
    //   state.loading = false;
    // },
    assignPermissionHandler: (state, action) => {
      state.assignedPermissions = action.payload;
    },
    unAssignedPermissionHandler: (state, action) => {
      state.unAssignedPermissions = action.payload;
    },
    clearAllPermission: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBranchRole = false;
      state.branchRole = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBranchRoleById.pending, (state) => {
      state.loading = true;
      state.edit = true;
    });
    builder.addCase(getBranchRoleById.fulfilled, (state, action) => {
      state.loading = false;
      //  state.edit = true;
      state.branchRole = action.payload.data;
    });
    builder.addCase(getBranchRoleById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateBranchRole.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBranchRole.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateBranchRole.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(loadOptionsBranchRolePermission.pending, (state) => {
      // state.loadingUpdated = true;
      state.unAssignedPermissions = [];
    });
    builder.addCase(loadOptionsBranchRolePermission.fulfilled, (state, action) => {
      // state.loadingUpdated = false;
      state.unAssignedPermissions = action.payload.data;
    });
    builder.addCase(loadOptionsBranchRolePermission.rejected, (state) => {
      // state.loadingUpdated = false;
      state.unAssignedPermissions = [];
    });
    builder.addMatcher(
      isAnyOf(
        getBranchRole.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingBranchRole = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranchRole.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBranchRole = false;
        state.branchRoles = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranchRole.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBranchRole = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  branchRoleEditSuccess,
  assignPermissionHandler,
  unAssignedPermissionHandler,
  clearAllPermission,
} = branchRoleSlice.actions;

export default branchRoleSlice.reducer;
